(function(algolia) {
  'use strict';

  var searchFilters = [];
  const getAlgoliaResults = algolia.externals.getAlgoliaResults;
  const { config, translations, headerTemplate, productTemplate, footerTemplate } = algolia;

  // Filters for stock policy
  let stockPolicyFilter = '';

  if (algolia.config.stock_policy === 'deny') {
    // For 'deny' we will filter out all items based on inventory quantity
    stockPolicyFilter = 'inventory_quantity > 0';
  } else if (algolia.config.stock_policy === 'continue') {
    /**
     * For 'continue' we will filter on `inventory_available` attribute whose
     * value is dependent on:
     * `inventory_quantity > 0 OR inventory_policy == 'continue'`
     */
    stockPolicyFilter = 'inventory_available:true';
  }

  // Add the stock policy filter to the list of search filters
    if (stockPolicyFilter) {
      searchFilters.push(stockPolicyFilter);
    }

   /* 
      Get list of all brand exclusions based on current 
      rules - add brand exclusion filters for each
  */
  algolia_exclusions.forEach(function(value) {
    if (value.trim() !== "") {
      var brandExclusionFilter = 'NOT vendor:"' + value.trim() + '"';
      searchFilters.push(brandExclusionFilter);
      //console.log(brandExclusionFilter);
    }
  });

  // Exclude Custom Products
  var brandExclusionFilter = 'NOT product_type:"_Custom Product"';
  searchFilters.push(brandExclusionFilter);

  // Exclude Hidden Products
  var hiddenExclusionFilter = 'NOT product_type:"OPTIONS_HIDDEN_PRODUCT"';
  searchFilters.push(hiddenExclusionFilter);
  
  // Exclude Products w/ Hide Search Filter
  var hideSearchFilter = "NOT tags:*hidesearch";
  searchFilters.push(hideSearchFilter);
  

  algolia.productsPlugin = {
    getSources({ query, setContext }) {
      return [
        {
          sourceId: 'products',
          getItems() {
            return getAlgoliaResults({
              searchClient: algolia.searchClient,
              queries: [
                {
                  indexName: config.index_prefix + 'products',
                  query,
                  params: {
                    hitsPerPage: config.products_autocomplete_hits_per_page,
                    clickAnalytics: config.analytics_enabled,
                    filters: searchFilters ? searchFilters.join(' AND ') : '',
                    distinct: algolia.config.show_products
                  },
                },
              ],
              transformResponse({ results, hits }) {
                setContext({
                  nbProducts: results[0].nbHits,
                });
                return hits;
              },
            });
          },
          templates: {
            header({ html, state }) {
              const resource = translations.products;
              return headerTemplate({ html, state }, resource);
            },
            item({ item, html, components }) {
              const distinct = config.show_products;
              const variantInfo = !distinct && item.objectID !== item.id ? `?variant= ${item.objectID}` : '';
              const itemLink = `/products/${item.handle}/${variantInfo}`;
              const getConversionData = (e, item) => {
                if (!algolia.config.analytics_enabled) return;
                // algolia.saveForConversionTracking({
                  // eventName: 'Added to cart',
                  // index: item.__autocomplete_indexName,
                  // objectIDs: [item.objectID],
                  // queryID: item.__autocomplete_queryID,
                // });
              }
              return productTemplate({ item, html, components }, distinct, itemLink, getConversionData);
            },
            footer({ state, html }){
              const {autocomplete_see_all, products_autocomplete_hits_per_page} = config;
              const showFooter = autocomplete_see_all && state.context.nbProducts > products_autocomplete_hits_per_page
              return showFooter && footerTemplate({ html, state });
            },
          },
        }
      ];
    },
  }
})(window.algoliaShopify);




